import { usePocQuery } from 'core/custom-hooks/use-poc-query.hook';
import { tenantUserKeys } from 'core/query-client/keys/tenant-users.keys';
import { TenantUsersList } from 'modules/settings/pods/settings-user-location-assignment/settings-user-location-assignment.vm';
import { getTenantUsers } from '../tenant-users.service';

export const useTenantUsersListQuery = () => {
    // Called bare instead of through executeRequest: a failed refresh must keep showing the last known
    // list without an error notification (POC-20586 AC Group 5), and executeRequest always raises one.
    const { data, isLoading, isFetching, isError, refetch } = usePocQuery<TenantUsersList>({
        queryKey: tenantUserKeys.list(),
        queryFn: getTenantUsers,
    });

    return {
        users: data?.users ?? [],
        isLoading: isLoading || isFetching,
        // Two different failures: degraded still has last-known rows to show, hasFailedToLoad has
        // none. Without the split, a first-load failure reads as an empty tenant.
        isDegraded: isError && data !== undefined,
        hasFailedToLoad: isError && data === undefined,
        isError,
        refetch,
    };
};
